var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemLabelSet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M15.854 2a3 3 0 0 1 2.467 1.293l3.457 4.995c.296.435.296.989.004 1.418l-1.615 2.333 1.655 2.392a1 1 0 0 1 0 1.138l-3.853 5.569c-.374.54-.989.862-1.645.862H4a2 2 0 0 1-2-2V5c0-1.654 1.345-3 3-3Zm.47 8H4v10h12.324l3.46-5zM16 14a1 1 0 1 1 0 2 1 1 0 1 1 0-2m-.146-10H5a1 1 0 0 0-1 1v3h12.324c.656 0 1.271.322 1.645.862l.982 1.419L19.84 9l-3.162-4.568A1 1 0 0 0 15.854 4"
})));
export default SvgGemLabelSet;